import {css} from '@emotion/core';
import {ICARE_GREY_DARKER, ICARE_GREY_LIGHTER, ICARE_PURPLE, ICARE_BLUE_LIGHT, ICARE_BLACK} from '~/core/styles/colors';
import {pulseBar} from '~/core/styles/themes';
import bp from '~/core/styles/breakpoints';

const footerPaddingSide = 60;
const footerPaddingSideM = footerPaddingSide - 30;

const footerGlobalStyle = css`
	.global-footer {
		background-color: ${ICARE_GREY_DARKER};
		color: ${ICARE_GREY_LIGHTER};
		position: relative;
		margin-top: auto;

		&::after {
			position: absolute;
			bottom: 0;
			left: 0;
			content: '';
			width: 100%;
			height: 6px;
			${pulseBar(ICARE_PURPLE, ICARE_BLUE_LIGHT, '13.5%')}
		}

		${bp(
			css`
				&::after {
					${pulseBar(ICARE_PURPLE, ICARE_BLUE_LIGHT, '180px')}
				}
			`,
			0,
			'm',
		)}
	}

	.global-footer__content {
		display: flex;
		justify-content: space-between;
		padding-top: 60px;
		padding-bottom: 114px;
		padding-left: ${footerPaddingSide}px;
		font-size: 16px;

		${bp(
			css`
				flex-direction: column;
				padding-left: ${footerPaddingSideM}px;
				padding-bottom: 60px;
			`,
			0,
			'm',
		)}
	}

	.global-footer__logo {
		flex: 1;
	}

	.global-footer__nav {
		flex: 2;
		margin: 0;
		padding: 0;
		max-height: 60px;
		display: flex;
		flex-wrap: wrap;
		justify-content: space-around;
		flex-direction: column;

		${bp(
			css`
				margin: 60px 0;
				justify-content: space-between;
				max-height: 250px;
				& > span {
					margin: 8px 0;
				}
			`,
			0,
			'm',
		)}
	}

	.global-footer__social {
		flex: 1;
		nav {
			display: flex;
			flex-wrap: wrap;
			margin-top: 15px;
			align-items: flex-start;

			& > a {
				display: block;
				width: 20px;
				height: 20px;
				margin-right: 15px;
			}
		}
	}

	.global-footer__copyright {
		padding-left: ${footerPaddingSide}px;
		min-height: 60px;
		background-color: ${ICARE_BLACK};
		display: flex;
		flex-direction: column;
		justify-content: center;

		span {
			font-size: 12px;
			color: ${ICARE_GREY_LIGHTER};
		}

		${bp(
			css`
				padding-left: ${footerPaddingSideM};
			`,
			0,
			'm',
		)}
	}
`;

export default {
	footerGlobalStyle,
};
